import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "record-detail-page app-page app-page--fill" }
const _hoisted_2 = {
  class: "detail-body",
  "element-loading-text": "加载中..."
}
const _hoisted_3 = { class: "summary-grid" }
const _hoisted_4 = { class: "summary-item" }
const _hoisted_5 = { class: "summary-value" }
const _hoisted_6 = { class: "summary-item" }
const _hoisted_7 = { class: "summary-value" }
const _hoisted_8 = { class: "summary-item" }
const _hoisted_9 = { class: "summary-value" }
const _hoisted_10 = { class: "summary-item" }
const _hoisted_11 = { class: "summary-value" }
const _hoisted_12 = {
  key: 0,
  class: "summary-item"
}
const _hoisted_13 = { class: "summary-value" }
const _hoisted_14 = {
  key: 1,
  class: "summary-item"
}
const _hoisted_15 = { class: "summary-value" }
const _hoisted_16 = {
  key: 0,
  class: "field-tabs-shell"
}
const _hoisted_17 = ["aria-selected", "onClick"]
const _hoisted_18 = { class: "field-table-viewport" }
const _hoisted_19 = {
  key: 0,
  class: "tag-list"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "remark-image-list"
}
const _hoisted_23 = ["title"]
const _hoisted_24 = {
  key: 1,
  class: "remark-thumb remark-thumb--placeholder"
}
const _hoisted_25 = { key: 1 }

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ArrowLeft } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import PageHeader from '@/components/PageHeader.vue';
import { ParameterSettings, list } from '@/network/index';
import { useRouteTitle } from '@/utils/useRouteTitle';


export default /*@__PURE__*/_defineComponent({
  __name: 'recordDetails',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const pageTitle = useRouteTitle('体检记录详情');

const loading = ref(false);
const recordDetail = ref<any | null>(null);
const remarkImageCache = ref<Record<string, { url: string; loading: boolean; error: boolean }>>({});
const activeFieldCategory = ref('');
const fieldTabNavRef = ref<HTMLElement | null>(null);
const fieldTabButtonRefs = ref<HTMLElement[]>([]);
const fieldTabIndicator = ref({ left: 0, width: 0 });

const formatDateText = (value: any): string => {
  if (!value) return '-';
  return String(value).replace('T', ' ');
};

const getRecordFields = () => {
  const fields = recordDetail.value?.房屋建筑定期体检数据采集原始子表集合;
  return Array.isArray(fields) ? fields : [];
};

const groupedFields = computed(() => {
  const groupMap = new Map<string, any[]>();
  getRecordFields()
    .slice()
    .sort((a: any, b: any) => Number(a?.index ?? 0) - Number(b?.index ?? 0))
    .forEach((item: any) => {
      const category = item?.所属类别 || '未分类';
      if (!groupMap.has(category)) groupMap.set(category, []);
      groupMap.get(category)?.push(item);
    });

  return Array.from(groupMap.entries()).map(([category, items]) => ({
    category,
    items
  }));
});

const activeFieldGroup = computed(() => {
  return groupedFields.value.find((group) => group.category === activeFieldCategory.value) || groupedFields.value[0];
});

watch(groupedFields, (groups) => {
  fieldTabButtonRefs.value = [];
  if (!groups.length) {
    activeFieldCategory.value = '';
    return;
  }
  if (!groups.some((group) => group.category === activeFieldCategory.value)) {
    activeFieldCategory.value = groups[0].category;
  }
  updateFieldTabIndicator();
});

const getFieldGroupIndex = (category: string) => {
  return groupedFields.value.findIndex((group) => group.category === category);
};

const fieldTabIndicatorStyle = computed(() => {
  return {
    width: `${fieldTabIndicator.value.width}px`,
    transform: `translateX(${fieldTabIndicator.value.left}px)`
  };
});

const setFieldTabButtonRef = (el: Element | null, index: number) => {
  if (el instanceof HTMLElement) {
    fieldTabButtonRefs.value[index] = el;
  }
};

const updateFieldTabIndicator = async () => {
  await nextTick();
  const activeIndex = getFieldGroupIndex(activeFieldCategory.value);
  const activeButton = fieldTabButtonRefs.value[activeIndex];
  const nav = fieldTabNavRef.value;
  if (!activeButton || !nav) {
    fieldTabIndicator.value = { left: 0, width: 0 };
    return;
  }

  fieldTabIndicator.value = {
    left: activeButton.offsetLeft - nav.scrollLeft,
    width: activeButton.offsetWidth
  };
};

const setActiveFieldCategory = (category: string) => {
  activeFieldCategory.value = category;
};

const handleWindowResize = () => {
  updateFieldTabIndicator();
};

const isOptionType = (row: any) => row?.数据类型 === '选项' || row?.数据类型 === '多选';

const getSelectedOptions = (row: any): string[] => {
  const selectedRequired = Array.isArray(row?.已选必选项) ? row.已选必选项 : [];
  const selectedOptional = Array.isArray(row?.已选可选项) ? row.已选可选项 : [];
  const merged = [...selectedRequired, ...selectedOptional].filter(Boolean);
  if (merged.length) return merged.map(String);
  return row?.数据值 ? String(row.数据值).split(',').map(item => item.trim()).filter(Boolean) : [];
};

const getRemarkImages = (row: any): any[] => {
  if (Array.isArray(row?.备注图像列表)) return row.备注图像列表;
  if (typeof row?.备注图像列表json === 'string') {
    try {
      const parsed = JSON.parse(row.备注图像列表json);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const getRemarkImageName = (image: any): string => {
  if (typeof image === 'string') return image.trim();
  if (!image || typeof image !== 'object') return '';
  return String(
    image.名称 ??
      image.fileName ??
      image.文件名 ??
      image.name ??
      image.图片名称 ??
      ''
  ).trim();
};

const parseDownloadResponseToUrl = (res: any): string => {
  if (res instanceof Blob) {
    return URL.createObjectURL(res);
  }

  const data = res?.response ?? res?.data ?? res;
  if (data instanceof Blob) {
    return URL.createObjectURL(data);
  }

  if (typeof data === 'string') {
    if (data.startsWith('http') || data.startsWith('blob:') || data.startsWith('data:')) {
      return data;
    }
    return `data:image/jpeg;base64,${data}`;
  }

  return '';
};

const setRemarkImageState = (fileName: string, state: Partial<{ url: string; loading: boolean; error: boolean }>) => {
  remarkImageCache.value = {
    ...remarkImageCache.value,
    [fileName]: {
      ...(remarkImageCache.value[fileName] || { url: '', loading: false, error: false }),
      ...state
    }
  };
};

const clearRemarkImageCache = () => {
  Object.values(remarkImageCache.value).forEach((item) => {
    if (item.url?.startsWith('blob:')) {
      URL.revokeObjectURL(item.url);
    }
  });
  remarkImageCache.value = {};
};

const getRemarkImageUrl = (image: any): string => {
  const fileName = getRemarkImageName(image);
  return fileName ? remarkImageCache.value[fileName]?.url || '' : '';
};

const getRemarkImagePlaceholderText = (image: any): string => {
  const fileName = getRemarkImageName(image);
  if (!fileName) return '无名称';
  return remarkImageCache.value[fileName]?.loading ? '加载中' : '加载失败';
};

const getRemarkPreviewList = (row: any): string[] => {
  return getRemarkImages(row)
    .map((image) => getRemarkImageUrl(image))
    .filter(Boolean);
};

const getRemarkImagePreviewIndex = (row: any, image: any): number => {
  const currentUrl = getRemarkImageUrl(image);
  const index = getRemarkPreviewList(row).findIndex((url) => url === currentUrl);
  return index > -1 ? index : 0;
};

const loadRemarkImage = async (fileName: string) => {
  if (!fileName) return;
  const cached = remarkImageCache.value[fileName];
  if (cached?.url || cached?.loading) return;

  setRemarkImageState(fileName, { loading: true, error: false });
  try {
    const res = await list.downloadPhoto({ 文件名: fileName });
    const url = parseDownloadResponseToUrl(res);
    if (!url) throw new Error('图片内容为空');
    setRemarkImageState(fileName, { url, loading: false, error: false });
  } catch (error) {
    console.warn(`加载备注图片失败: ${fileName}`, error);
    setRemarkImageState(fileName, { url: '', loading: false, error: true });
  }
};

const loadAllRemarkImages = () => {
  const fileNames = Array.from(new Set(
    getRecordFields()
      .flatMap((row: any) => getRemarkImages(row).map((image) => getRemarkImageName(image)))
      .filter(Boolean)
  ));
  fileNames.forEach((fileName) => {
    loadRemarkImage(fileName);
  });
};

const refreshActiveTableLayout = async () => {
  await nextTick();
  window.dispatchEvent(new Event('resize'));
};

const loadRecordDetail = async () => {
  const id = route.query.id;
  if (!id) {
    ElMessage.warning('缺少体检记录ID');
    return;
  }

  try {
    loading.value = true;
    clearRemarkImageCache();
    const res = await ParameterSettings.houseCheckPlanRecordDetailById({ id });
    if (res && res.status === 200 && res.success && res.response) {
      recordDetail.value = res.response;
      loadAllRemarkImages();
    } else {
      recordDetail.value = null;
      ElMessage.error(res?.msg || '加载体检记录详情失败');
    }
  } catch (error) {
    console.error('加载体检记录详情失败:', error);
    recordDetail.value = null;
    ElMessage.error('加载体检记录详情失败');
  } finally {
    loading.value = false;
  }
};

const goBack = () => {
  router.back();
};

onMounted(() => {
  loadRecordDetail();
  window.addEventListener('resize', handleWindowResize);
});

watch(activeFieldCategory, () => {
  refreshActiveTableLayout();
  updateFieldTabIndicator();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleWindowResize);
  clearRemarkImageCache();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader, {
      size: "page",
      divider: ""
    }, {
      title: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(ArrowLeft),
          onClick: goBack
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("返回")
          ])),
          _: 1
        }, 8, ["icon"]),
        _createElementVNode("span", null, _toDisplayString(_unref(pageTitle)), 1)
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (!recordDetail.value && !loading.value)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "暂无体检记录详情"
          }))
        : (recordDetail.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_card, {
                class: "summary-card",
                shadow: "hover"
              }, {
                header: _withCtx(() => [
                  _createVNode(PageHeader, { size: "card" }, {
                    title: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("基本信息")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "summary-label" }, "评估类型", -1)),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(recordDetail.value.评估类型 || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "summary-label" }, "体检人员", -1)),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(recordDetail.value.体检人员 || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "summary-label" }, "提交时间", -1)),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(formatDateText(recordDetail.value.提交时间)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "summary-label" }, "数据唯一ID", -1)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(recordDetail.value.数据唯一ID || '-'), 1)
                    ]),
                    (recordDetail.value.项目名称 || recordDetail.value.项目编码)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "summary-label" }, "项目名称", -1)),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(recordDetail.value.项目名称 || '-'), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (recordDetail.value.项目名称 || recordDetail.value.项目编码)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "summary-label" }, "项目编码", -1)),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(recordDetail.value.项目编码 || '-'), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                class: "fields-card",
                shadow: "hover"
              }, {
                header: _withCtx(() => [
                  _createVNode(PageHeader, { size: "card" }, {
                    title: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("采集数据")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  (groupedFields.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", {
                          ref_key: "fieldTabNavRef",
                          ref: fieldTabNavRef,
                          class: "field-tab-nav",
                          role: "tablist",
                          onScroll: updateFieldTabIndicator
                        }, [
                          _createElementVNode("div", {
                            class: "field-tab-indicator",
                            style: _normalizeStyle(fieldTabIndicatorStyle.value)
                          }, null, 4),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedFields.value, (group, groupIndex) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: group.category,
                              ref_for: true,
                              ref: (el) => setFieldTabButtonRef(el, groupIndex),
                              class: _normalizeClass(["field-tab-button", { 'field-tab-button--active': group.category === activeFieldCategory.value }]),
                              type: "button",
                              role: "tab",
                              "aria-selected": group.category === activeFieldCategory.value,
                              onClick: ($event: any) => (setActiveFieldCategory(group.category))
                            }, _toDisplayString(group.category), 11, _hoisted_17))
                          }), 128))
                        ], 544),
                        _createElementVNode("div", _hoisted_18, [
                          (activeFieldGroup.value)
                            ? (_openBlock(), _createBlock(_component_el_table, {
                                key: 0,
                                data: activeFieldGroup.value.items,
                                border: "",
                                stripe: "",
                                size: "small",
                                class: "field-table"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "字段名称",
                                    label: "字段名称",
                                    "min-width": "180",
                                    "show-overflow-tooltip": ""
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "数据类型",
                                    label: "数据类型",
                                    width: "110"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    label: "采集值",
                                    "min-width": "260",
                                    "show-overflow-tooltip": ""
                                  }, {
                                    default: _withCtx(({ row }) => [
                                      (isOptionType(row))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSelectedOptions(row), (item) => {
                                              return (_openBlock(), _createBlock(_component_el_tag, {
                                                key: item,
                                                type: "success",
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128)),
                                            (!getSelectedOptions(row).length)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(row.数据值 || '-'), 1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "预显备注",
                                    label: "预显备注",
                                    "min-width": "180",
                                    "show-overflow-tooltip": ""
                                  }, {
                                    default: _withCtx(({ row }) => [
                                      _createTextVNode(_toDisplayString(row.预显备注 || '-'), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    label: "备注图片",
                                    "min-width": "180",
                                    align: "center"
                                  }, {
                                    default: _withCtx(({ row }) => [
                                      (getRemarkImages(row).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRemarkImages(row), (image, imageIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: `${getRemarkImageName(image)}-${imageIndex}`,
                                                class: "remark-image-item",
                                                title: getRemarkImageName(image)
                                              }, [
                                                (getRemarkImageUrl(image))
                                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                                      key: 0,
                                                      class: "remark-thumb",
                                                      src: getRemarkImageUrl(image),
                                                      "preview-src-list": getRemarkPreviewList(row),
                                                      "initial-index": getRemarkImagePreviewIndex(row, image),
                                                      fit: "cover",
                                                      "preview-teleported": "",
                                                      "hide-on-click-modal": ""
                                                    }, null, 8, ["src", "preview-src-list", "initial-index"]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(getRemarkImagePlaceholderText(image)), 1))
                                              ], 8, _hoisted_23))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createBlock(_component_el_empty, {
                        key: 1,
                        description: "暂无采集数据"
                      }))
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true)
    ])), [
      [_directive_loading, loading.value]
    ])
  ]))
}
}

})